import React, {Component} from 'react';
import {withRouter, Link} from 'react-router-dom';

class SidebarLink extends Component {
    render(){
        if(this.props.courseId){
            return (
                <Link to={`/admin/${this.props.courseId}/${this.props.view}`} className={this.props.className || ''}>{this.props.title}</Link>
            )
        }else{
            return (
                <Link to={`/admin/${this.props.view}`} className={this.props.className || ''}>{this.props.title}</Link>
            )
        }
    }
}

export default SidebarLink;


// WEBPACK FOOTER //
// ./src/components/AdminConsole/SidebarLink.js